import { Component } from '@angular/core';
import { LoaderService } from '../../services';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'ui-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent {

  constructor(
    private loaderService: LoaderService
  ) { }

  get show(): Observable<boolean> {
    return this.loaderService.getLoader().
      pipe(
        map(loaderState => loaderState ? loaderState.show : false)
      );
  }

  get message(): Observable<string | null> {
    return this.loaderService.getLoader().
      pipe(
        map(loaderState => loaderState ? loaderState.message : null)
      );
  }

}
